import React, { useState } from "react";
import {
  Box,
  HStack,
  IconButton,
  Tooltip,
  FormControl,
  FormLabel,
  Switch,
  Input,
  VStack,
  Text,
  Button,
  List,
  ListItem,
} from "@chakra-ui/react";
import {
  DeleteIcon,
  CopyIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  CloseIcon,
} from "@chakra-ui/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
function DraggableMatrixCreationElement({
  
  element,
  onDelete,
  onCopy,
  onMoveUp,
  onMoveDown,
  onChangeData,



  isMatrixDropdownElement,
  onDeleteMatrixDropdown,

  onCopyMatrixDropdown,
  onMoveUpMatrixDropdown,
  onMoveDownMatrixDropdown

}) {
  const {t} = useTranslation();

  useEffect(() => {
    
    if (element.isRequired == null) {
      onChangeData(element.id, "isRequired", false);
    }
  }, [element, onChangeData]);

  

  

  const [newColumn, setNewColumn] = useState({ value: "", text: "" });
  const [newRow, setNewRow] = useState({ value: "", text: "" });


  
  const [columns, setColumns] = useState(element.columns ||[]);
  const [rows, setRows] = useState(element.rows ||[]);


  const handleAddColumn = () => {
    if (newColumn.value && newColumn.text) {
      const isDuplicate = columns.some(
        (col) => col.value === newColumn.value && col.text === newColumn.text
      );
  
      if (!isDuplicate) {
        const updatedColumns = [...columns, newColumn]; // Aggiorna localmente l'array delle colonne
        setColumns(updatedColumns); // Aggiorna lo stato locale delle colonne
        onChangeData(element.id, "columns", updatedColumns); // Notifica l'aggiornamento tramite onChangeData
        setNewColumn({ value: "", text: "" }); // Resetta l'oggetto colonna
      } 
    }
  };
  
  const handleAddRow = () => {
    if (newRow.value && newRow.text) {
      const isDuplicate = rows.some(
        (row) => row.value === newRow.value && row.text === newRow.text
      );
  
      if (!isDuplicate) {
        const updatedRows = [...rows, newRow]; // Aggiorna localmente l'array delle righe
        setRows(updatedRows); // Aggiorna lo stato locale delle righe
        onChangeData(element.id, "rows", updatedRows); // Notifica l'aggiornamento tramite onChangeData
        setNewRow({ value: "", text: "" }); // Resetta l'oggetto riga
      } 
    }
  };
  
  const handleRemoveColumn = (columnToRemove) => {
    const updatedColumns = columns.filter(
      (column) => column.value !== columnToRemove.value || column.text !== columnToRemove.text
    ); // Rimuove la colonna che ha esattamente lo stesso valore e testo
    setColumns(updatedColumns); // Aggiorna lo stato locale delle colonne
    onChangeData(element.id, "columns", updatedColumns); // Notifica l'aggiornamento tramite onChangeData
  };
  
  const handleRemoveRow = (rowToRemove) => {
    const updatedRows = rows.filter(
      (row) => row.value !== rowToRemove.value || row.text !== rowToRemove.text
    ); // Rimuove la riga che ha esattamente lo stesso valore e testo
    setRows(updatedRows); // Aggiorna lo stato locale delle righe
    onChangeData(element.id, "rows", updatedRows); // Notifica l'aggiornamento tramite onChangeData
  };
  

  
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      p={6}
      shadow="md"
      position="relative"
      width="100%"
    >
      {/* Action Buttons */}
      <HStack spacing={2} position="absolute" top={2} left={2}>

      
        <Text fontWeight="bold" fontSize="md">
          Matrix {t('survey.matrixQuestion.question')}
        </Text>
   
        <Tooltip label={t('survey.iconQuestion.delete')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Delete"
            icon={<DeleteIcon />}
            onClick={() => { isMatrixDropdownElement ? onDeleteMatrixDropdown() : onDelete() }}
          />
        </Tooltip>
        <Tooltip label={t('survey.iconQuestion.copy')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Copy"
            icon={<CopyIcon />}
            onClick={() => { isMatrixDropdownElement ? onCopyMatrixDropdown() : onCopy() }}
          />
        </Tooltip>
        <Tooltip label={t('survey.iconQuestion.moveUp')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Move Up"
            icon={<ArrowUpIcon />}
            onClick={() => { isMatrixDropdownElement ? onMoveUpMatrixDropdown() : onMoveUp() }}
          />
        </Tooltip>
        <Tooltip label={t('survey.iconQuestion.moveDown')} fontSize="sm">
          <IconButton
            size="sm"
            aria-label="Move Down"
            icon={<ArrowDownIcon />}
            onClick={() => { isMatrixDropdownElement ? onMoveDownMatrixDropdown() : onMoveDown() }}
          />
        </Tooltip>
      </HStack>

      <VStack align="start" spacing={5} mt={8}>
       

        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.matrixQuestion.title')}</FormLabel>
          <Input
            value={element.title}
            placeholder={t('survey.matrixQuestion.enterTitle')}
            onChange={(e) => onChangeData(element.id,"title", e.target.value)}
          />
        </FormControl>


        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.matrixQuestion.tag')}</FormLabel>
          <Input
            value={element.name}
            placeholder={t('survey.matrixQuestion.enterTag')}
            onChange={(e) => onChangeData(element.id, "name", e.target.value)}
          />
         </FormControl>
      


        {/* Columns */}
        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.matrixQuestion.columns')}</FormLabel>

          <HStack width="100%" spacing={3} align="center">
  <Input
    placeholder={t('survey.matrixQuestion.columnValue')}
    value={newColumn.value}
    width="40%"  // Set a fixed width to inputs to allow space for the button
    onChange={(e) => setNewColumn({ ...newColumn, value: e.target.value })}
  />
  <Input
    placeholder={t('survey.matrixQuestion.columnText')}
    value={newColumn.text}
    width="40%"  // Set a fixed width to inputs to allow space for the button
    onChange={(e) => setNewColumn({ ...newColumn, text: e.target.value })}
  />
  <Button 
    colorScheme="blue" 
    onClick={handleAddColumn}
    width="20%"    // Ensures the button takes up remaining space, keeping it visible
    minWidth="100px" // Ensures button is not too small even on wider screens
  >
    {t('survey.matrixQuestion.addColumn')}
  </Button>
</HStack>

          <VStack align="start" spacing={2} width="100%" maxHeight="350px" overflowY="auto">
            <List spacing={2} width="100%">
              {columns.map((column, index) => (
                <ListItem
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="md"
                  p={2}
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  <Tooltip label={column.text} aria-label="Column Text Tooltip">
                  <Text>{t('survey.matrixQuestion.value')}: {column.value} {t('survey.matrixQuestion.text')}:{column.text}</Text>
                  </Tooltip>
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    aria-label="Remove column"
                    onClick={() => handleRemoveColumn(column)}
                  />
                </ListItem>
              ))}
            </List>
           
          </VStack>
        </FormControl>

        {/* Rows */}
        <FormControl>
          <FormLabel fontWeight="bold">{t('survey.matrixQuestion.rows')}</FormLabel>
     
          <HStack width="100%" spacing={3} align="center">
  <Input
    placeholder={t('survey.matrixQuestion.rowValue')}
    value={newRow.value}
    width="40%"  // Set a fixed width to inputs to allow space for the button
    onChange={(e) => setNewRow({ ...newRow, value: e.target.value })}
  />
  <Input
    placeholder={t('survey.matrixQuestion.rowText')}
    value={newRow.text}
    width="40%"  // Set a fixed width to inputs to allow space for the button
    onChange={(e) => setNewRow({ ...newRow, text: e.target.value })}
  />
  <Button 
    colorScheme="blue" 
    onClick={handleAddRow}
    width="20%"    // Ensures the button takes up remaining space, keeping it visible
    minWidth="100px" // Ensures button is not too small even on wider screens
  >
    {t('survey.matrixQuestion.addRow')}
  </Button>
</HStack>

          <VStack align="start" spacing={2} width="100%" maxHeight="350px" overflowY="auto">
            <List spacing={2} width="100%">
              {rows.map((row, index) => (
                <ListItem
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="md"
                  p={2}
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  <Tooltip label={row.text} aria-label="Row Text Tooltip">
                    <Text>{t('survey.matrixQuestion.value')}: {row.value} {t('survey.matrixQuestion.text')}:{row.text}</Text>
                  </Tooltip>
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    aria-label="Remove row"
                    onClick={() => handleRemoveRow(row)}
                  />
                </ListItem>
              ))}
            </List>
          
          </VStack>
        </FormControl>

        <FormControl display="flex" alignItems="center">
          <FormLabel mb="0" fontWeight="bold">
            {t('survey.matrixQuestion.required')}
          </FormLabel>
          <Switch
            isChecked={element.isRequired}
            onChange={(e) => onChangeData(element.id,"isRequired", e.target.checked)}
          />
        </FormControl>
      </VStack>
    </Box>
  );
}

export default DraggableMatrixCreationElement;
